module.exports = __webpack_public_path__ + "static/img/eckgesimse.597cc5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat/eckgesimse.png
// module id = vhgg
// module chunks = 1